import {Component, Input, OnInit} from '@angular/core';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {DataService} from '../../services/data.service';
import {ExcTranslation} from 'exc-core-v2';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-layout-table',
  templateUrl: './layout-table.component.html',
})
export class LayoutTableComponent extends ExcTranslation implements OnInit {
  @Input()
  mainTable?: any;

  config = {
    table: {
      unselected: [],
      selected: [],
      searchValue: '',
      selectKey: 'field',
      selectedRow: undefined as any,
      selectionChanged: (index: number) => {
        this.config.table.selectedRow = this.mainTable[index];
      },
      search(value: string): void {
        this.searchValue = value;
      },
      drop(event: CdkDragDrop<any, any>): void {
        if (event.previousContainer === event.container) {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex,
          );
        }
      }
    }
  };

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.config.table.unselected = this.mainTable;
  }
}
